// DS: MO2.5
import React, { useState, useMemo, useContext } from 'react';
import ModalWrapper from '@wix/da-ds/pkg/modals/ModalWrapper/ModalWrapper';
import c from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useTranslation } from 'react-i18next';
import { getRecipientSectionName } from '../../utils';
import Popover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { ResourceType } from '../../../types/resource';
import Badge from '@wix/da-ds/pkg/Badge';
import { URLS } from '@wix/da-url';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import AwardsPopupContents from './AwardsPopupContents';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './AwardsPopup.scss';
const AwardsPopup = ({ defaultActiveType, recipient, typeId, itemId, badges, isOwner, requestClose, onAwardClick })=>{
    var _badgesByType_activeType;
    const isMobile = useContext(MobileContext);
    const [activeType, setActiveType] = useState(defaultActiveType);
    const { t } = useTranslation();
    const countsByType = useMemo(()=>{
        const counts = {};
        badges.forEach((b)=>counts[b.name] = b.stackCount);
        return counts;
    }, [
        badges
    ]);
    const badgesByType = useMemo(()=>{
        const types = {};
        badges.forEach((b)=>types[b.name] = b);
        return types;
    }, [
        badges
    ]);
    const total = badges.reduce((a, b)=>a + (b.stackCount || 0), 0);
    const onCTAClick = ()=>{
        if (isOwner) {
            return window.location.assign(URLS.SUBMIT);
        }
        requestClose && requestClose();
        yieldToMain(()=>onAwardClick(recipient, typeId, itemId));
    };
    return /*#__PURE__*/ React.createElement(ModalWrapper, {
        isOpen: true,
        className: c(!isMobile && s['root']),
        hasCloseButton: false
    }, /*#__PURE__*/ React.createElement(Popover, {
        headerIllustration: activeType ? /*#__PURE__*/ React.createElement(Badge, {
            badge: badgesByType[activeType]
        }) : undefined,
        heading: activeType ? t('coreBadge.awardsPopup.selectedBadge.title', {
            badgeTitle: (_badgesByType_activeType = badgesByType[activeType]) === null || _badgesByType_activeType === void 0 ? void 0 : _badgesByType_activeType.baseTitle
        }) : t('coreBadge.awardsPopup.title'),
        subheading: activeType ? t('coreBadge.awardsPopup.selectedBadge.subtitle', {
            count: countsByType[activeType],
            total
        }) : t('coreBadge.awardsPopup.subtitle', {
            total
        }),
        onBackClick: activeType ? ()=>setActiveType(undefined) : undefined,
        onCloseClick: requestClose,
        content: /*#__PURE__*/ React.createElement("div", {
            className: s['content']
        }, activeType ? /*#__PURE__*/ React.createElement(AwardsPopupContents, {
            type: activeType,
            recipient: recipient,
            count: countsByType[activeType]
        }) : badges.map((badge)=>/*#__PURE__*/ React.createElement(ListItemButton, {
                key: badge.id,
                prefix: /*#__PURE__*/ React.createElement(Badge, {
                    badge: badge,
                    className: s['badge-icon']
                }),
                label: badge.baseTitle,
                subLabel: `${badge.stackCount}`,
                suffixIcon: ArrowRight,
                biData: BiData({
                    evid: 322,
                    badge_typeid: badge.typeId,
                    badge_type: badge.name,
                    sectiontype: 'badge_statistics',
                    sectionname: getRecipientSectionName(recipient.typeId),
                    typeid: recipient.typeId,
                    itemid: recipient.itemId
                }),
                onClick: ()=>{
                    setActiveType(badge.name);
                },
                fillContainerWidth: true
            }))),
        showHeaderBorder: true,
        showFooterBorder: true,
        footerMessage: isOwner ? t('coreBadge.awardsPopup.footer.owner') : t('coreBadge.awardsPopup.footer.visitor'),
        footerButtonLabel: isOwner ? t('coreBadge.awardsPopup.footerButton.owner') : t('coreBadge.awardsPopup.footerButton.visitor'),
        footerButtonOnClick: onCTAClick,
        footerButtonBiData: isOwner ? BiData({
            evid: 704,
            sectionname: 'badge_popup'
        }) : BiData({
            evid: 320,
            sectionname: recipient.typeId === ResourceType.DEVIATION ? 'deviation' : 'comment',
            itemid: recipient.itemId,
            typeid: recipient.typeId
        })
    }));
};
AwardsPopup.displayName = 'AwardsPopup';
export default AwardsPopup;

//# sourceMappingURL=AwardsPopup.js.map